import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions/constants";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionId: AllRouteEndpoints =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension/actions/:action_id";

export const putDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys: AllRouteEndpoints[] =
  [decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension];

export const deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys: AllRouteEndpoints[] =
  [
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension,
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions,
  ];
